import { call, take, cancel, fork } from 'redux-saga/effects';
import { delay, eventChannel } from 'redux-saga';
import { postContentResized, postReservationPlaced, postReservationFailed } from '../../services/iframe';

const windowResizedChannel = () => {
    return eventChannel(emit => {
        let func = () => emit(true);
        window.addEventListener('resize', func);
        return () => {
            func = () => { };
        };
    });
};

function* handleWindowSizeChange() {
    yield call(delay, 500);
    console.log('handlewindowresize', Date.now())
    yield call(postContentResized);
};

export function* contentResizedSaga() {
    let task;
    const chan = windowResizedChannel();
    while (true) {
        yield take(chan);
        if (task) {
            cancel(task);
        }
        task = yield fork(handleWindowSizeChange);
    }
}

export function* reservationPlacedSaga(action) {
    const payload = { prereservationId: action.payload.id, quantity: action.payload.numberOfPlayers }
    yield call(postReservationPlaced, payload);
}

export function* reservationFailedSaga(action) {
    yield call(postReservationFailed, action.payload)
}


// WEBPACK FOOTER //
// ./src/sagas/iframe/task.js